module.exports = __webpack_public_path__ + "static/media/top_three.9e8a67fd.svg";